module.exports = __webpack_public_path__ + "img/201800-2.fd4b8465.jpeg";